<h2 mat-dialog-title>{{title}}</h2>
<mat-dialog-content>
    <div>{{content}}</div>

    <br>

</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-raised-button mat-dialog-close color="primary">Close</button>
</mat-dialog-actions>